const getters = {
  getAllSubscriptions(state) {
    return state.allSubscriptions;
  },
  getSubscription(state) {
    return state.subscription;
  },
  getSubscriptionTemporal(state) {
    return state.subscriptionTemporal;
  },
  getSubscriptionsOverlay(state) {
    return state.subscriptionsOverlay;
  },
  getMenus(state) {
    return state.menus;
  },
  getMenuOptions(state) {
    return state.menuOptions;
  },
  getPlatesOptions(state) {
    return state.platesOptions;
  },
  getTags(state) {
    return state.tags;
  },
  getIngredients(state) {
    return state.ingredients;
  },
  getIncludeProteins(state) {
    return state.includeProteins;
  },
  getFoodRestrictions(state) {
    return state.foodRestrictions;
  },
  getMenuItems(state) {
    return state.menuItems;
  },
  getCurrentMenu(state) {
    return state.currentMenu;
  },
  getCurrentMenuOption(state) {
    return state.currentMenuOption;
  },
  getCurrentDay(state) {
    return state.currentDay;
  },
  getAllMenuItemProducts(state) {
    return state.allMenuItemProducts;
  },
  getSubscriptionDetails(store) {
    return store.subscriptionDetails;
  },
  getCarouselKey(store) {
    return store.carouselKey;
  },
  getMenuDetails(store) {
    return store.menuDetails;
  },
  getSelectedFirstDay(store) {
    return store.selectedFirstDay;
  },
  getDashboardSelectedTabIndex(store) {
    return store.dashboardSelectedTabIndex;
  },
  getMenuPrices(store) {
    return store.menuPrices;
  },
  getDishToReplace(store) {
    return store.dishToReplace;
  },
  getIngredientToReplace(store) {
    return store.ingredientToReplace;
  },
};

export default getters;
